import { FC, MouseEvent, PropsWithChildren, useEffect, useRef, useState } from 'react'

import { useOnClickOutside } from '../../hooks'
import * as S from './DropDownMenu.styles'
import { DropDownMenuProps } from './DropDownMenu.types'
import { DropDownMenuContent } from './DropDownMenuContent'

const DropDownMenu: FC<PropsWithChildren<DropDownMenuProps>> = ({
  className,
  children,
  items,
  disabled,
  verticalPosition = 'bottom',
  horizontalPosition = 'right',
  onMenuChange,
  handleOpenMenuAction,
  openMenuOn = 'click',
  width,
  height,
  isInitiallyOpen = false,
  disableHideOnClickOutside = false,
}) => {
  const [openMenu, setOpenMenu] = useState(isInitiallyOpen)
  const ref = useRef<HTMLDivElement | null>(null)

  useOnClickOutside(ref, () => (disableHideOnClickOutside ? null : setOpenMenu(false)))

  const itemsToMap = items.filter(item => !item.hidden)

  useEffect(() => {
    onMenuChange?.(openMenu)
  }, [openMenu, onMenuChange])

  const handleOpenMenu = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    if (!disabled) {
      handleOpenMenuAction?.(e)
      if (e.type === openMenuOn) {
        if (e.type === 'contextmenu') e.preventDefault()
        setOpenMenu(!openMenu)
      }
    }
  }

  return (
    <S.RelativeContainer className={className} ref={ref} width={width} height={height}>
      <S.ChildrenWrapper
        style={{ width: 'inherit', height: 'inherit' }}
        onClick={handleOpenMenu}
        onContextMenu={handleOpenMenu}
        isTriggerActive={openMenu}
      >
        {children}
      </S.ChildrenWrapper>

      {openMenu && itemsToMap.length > 0 && (
        <S.MenuContainer
          id="drop-down-menu"
          verticalPosition={verticalPosition}
          horizontalPosition={horizontalPosition}
        >
          <DropDownMenuContent itemsToMap={itemsToMap} onClickMenu={() => setOpenMenu(false)} />
        </S.MenuContainer>
      )}
    </S.RelativeContainer>
  )
}

export { DropDownMenu }
